var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#EA4C89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C18.1 12.5 12.5 18.1 12.5 25C12.5 31.9 18.1 37.5 25 37.5C31.875 37.5 37.5 31.9 37.5 25C37.5 18.1 31.875 12.5 25 12.5ZM33.25 18.25C34.75 20.075 35.625 22.375 35.675 24.9C35.325 24.825 31.8 24.125 28.25 24.55C28.175 24.375 28.1 24.175 28.025 24C27.8 23.475 27.575 22.95 27.325 22.45C31.225 20.875 33.025 18.55 33.25 18.25ZM25 14.35C27.7 14.35 30.2 15.375 32.075 17.025C31.875 17.3 30.275 19.45 26.475 20.875C24.725 17.65 22.775 15.025 22.5 14.625C23.3 14.45 24.125 14.35 25 14.35ZM20.45 15.35C20.725 15.725 22.625 18.375 24.4 21.525C19.4 22.85 15 22.825 14.525 22.825C15.25 19.5 17.475 16.75 20.45 15.35ZM14.325 25.025C14.325 24.925 14.325 24.8 14.325 24.7C14.775 24.725 19.975 24.775 25.3 23.175C25.6 23.775 25.9 24.375 26.175 25C26.05 25.05 25.9 25.075 25.75 25.125C20.25 26.9 17.325 31.75 17.075 32.15C15.35 30.25 14.325 27.75 14.325 25.025ZM25 35.675C22.525 35.675 20.25 34.825 18.45 33.425C18.65 33.025 20.8 28.85 26.825 26.75C26.85 26.725 26.875 26.725 26.9 26.725C28.4 30.625 29.025 33.875 29.175 34.825C27.9 35.375 26.475 35.675 25 35.675ZM30.95 33.85C30.85 33.2 30.275 30.075 28.875 26.25C32.225 25.725 35.15 26.6 35.525 26.7C35.05 29.675 33.35 32.25 30.95 33.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/Dribbble.9db9a73f80a88020cc2565750883cadd.svg";
export { ForwardRef as ReactComponent };